import barba from '@barba/core'
import { Accordion } from './commons/accordion.js'
import  Animation  from './commons/animations.js'
import  homeAnimations  from './commons/homeAnimations.js'
import { UserFilter } from './commons/userfilter.js'
import Slider from './commons/slider.js'
import Inview from './commons/inview.js'
import Modal from './commons/modal.js'
import Menu from './commons/menu.js'
import Search from './commons/search.js'
import Ods from './commons/ods.js'
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'
// import { pageHeaderBeforeEnterAnimation, pageHeaderEnterAnimation } from './animations/index.js';


const Components = new function () {
	this.init = () => {
		// Slider
		if (document.querySelector('.slider-wrapper')) {
			Slider.init();
		}
		
		const elements = document.querySelectorAll('.calc-height');
		elements.forEach(element => {
				const height = element.offsetHeight;
				element.style.setProperty('--element-height', `${height}px`);
			});
			
		// Accordion //-- Must Be Before Inview Init --//
		if (document.querySelector('.ss-accordion')) {
			Accordion.init();
		}
		
		// Modal
		if (document.querySelector('.ss-modal')) {
			Modal.init()
		}
		
		// Menu
		Menu.init()
		
		// Search
		Search.init()
		
		// ODS labels
		if (document.querySelector('.ss-ods')) {
			Ods.init()
		}

		// User Filter
		if (document.querySelector('.ss-user-filters')) {
			UserFilter.init();
		}

		// Inview
		if (document.querySelector('[data-inview]')) {
			Inview.init()
		}
	
		// Animations
		if(document.querySelector('.anim-js') && !document.querySelector('.ss-home')) {
			Animation.init();
		}
		if(document.querySelector('.ss-home')) {
			homeAnimations.init()
		}
	}
	
};

const App = new function () {

	this.init = () => {
		// Initial setup
		setWin()
		setVh()
		setVw()

		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)

		// Initialize components
		Components.init();
	
	
		// Barba
		barba.hooks.beforeEnter((data) => {
			const matches = data.next.html.match(/<body.+?class="([^""]*)"/i);
			document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
			document.querySelector('#ss-page').scrollTo(0, 0);

			// Components.init();
		});
		barba.hooks.beforeLeave(() => {
			if(document.querySelector('[data-inview]')) {
				Inview.kill()
			}
			if(document.querySelector('.anim-js') && !document.querySelector('.ss-home')) {
				Animation.kill()
			}
			if(document.querySelector('.ss-home')) {
				homeAnimations.kill()
			}
		})
		barba.hooks.after(() => {
			Components.init();
		})
		
		// Barba Init
		barba.init({
			preventRunning: true,
			transitions: [
				{
					sync: false,
					name: 'general-transition',
					beforeOnce() {
						document.querySelector('#ss-page').scrollTo(0, 0);
						
						const main = document.querySelector('.ss-main');
						const isHomePage = main.classList.contains('ss-home-main');

						gsap.set(main, {
							autoAlpha: 0,
						});

						if (!isHomePage) {
							// pageHeaderBeforeEnterAnimation(document);
							const pageHeader = document.querySelector('.ss-page-header');

							const pageHeaderTop = pageHeader.querySelector('.ss-page-header__top');
							const pageHeaderTopInner = pageHeader.querySelector('.ss-page-header__top h1');
							const pageHeaderTextContainer = pageHeader.querySelector('.ss-page-header-text');
							const pageHeaderText = pageHeader.querySelector('.ss-page-header-text p');
							const pageHeaderArrow = pageHeader.querySelector('.ss-page-header-arrow');
						
							if (pageHeader) {
								gsap.set(pageHeaderTop, {
									scaleY: 0,
									transformOrigin: "bottom"
								})
								gsap.set(pageHeaderTopInner, {
									autoAlpha: 0,
								})
								gsap.set(pageHeaderTextContainer, {
									scaleX: 0,
									transformOrigin:"left"
								})
								gsap.set(pageHeaderText, {
									autoAlpha: 0,
									y: "2rem",
								})
								gsap.set(pageHeaderArrow, {
									scaleY: 0,
									transformOrigin:"top"
								})
							}
						}
					},
					once() {
						const spinner = document.querySelector('.ss-spinner');
						gsap.set(spinner, {
                            autoAlpha: 0
                        });

						const main = document.querySelector('.ss-main');
						const pageHeader = document.querySelector('.ss-page-header');

						const tl = gsap.timeline()
							.addLabel('start')
							.to(main, {
								autoAlpha: 1,
								duration: 0.3,
								ease: "power1.inOut",
								clearProps: 'all',
							}, 'start');

						if (pageHeader) {
							// pageHeaderEnterAnimation(pageHeader);
							const pageHeaderTop = pageHeader.querySelector('.ss-page-header__top');
							const pageHeaderTopInner = pageHeader.querySelector('.ss-page-header__top h1');
							const pageHeaderTextContainer = pageHeader.querySelector('.ss-page-header-text');
							const pageHeaderText = pageHeader.querySelector('.ss-page-header-text p');
							const pageHeaderArrow = pageHeader.querySelector('.ss-page-header-arrow');
						
							tl.to(pageHeaderTop, {
								scaleY: 1,
								duration: 0.5,
								ease: "expo.out",
								clearProps: 'all',
							}, 'start+=0.3')
							.to(pageHeaderTopInner, {
								autoAlpha: 1,
								duration: 0.2,
								ease: "power3.inOut",
								clearProps: 'all',
							}, 'start+=0.8')
							.to(pageHeaderTextContainer, {
								scaleX: 1,
								duration: 0.6,
								ease: "expo.out",
								clearProps: 'all',
							}, 'start+=0.8')
							.to(pageHeaderText, {
								autoAlpha: 1,
								y: 0,
								duration: 0.4,
								ease: "power2.inOut",
								clearProps: 'all',
							}, 'start+=1.2')
							.to(pageHeaderArrow, {
								scaleY: 1,
								duration: 0.5,
								ease: "expo.out",
								clearProps: 'all',
							}, 'start+=1.5');
						}

					},
					async leave(data) {
						await new Promise(resolve => {
							document.body.classList.add('on-transition');
                            const currentDOM = data.current.container;
							
							const main = currentDOM.querySelector('.ss-main');

                            const tl = gsap.timeline()
                                .addLabel('start')
                                    .to(main, {
                                        autoAlpha: 0,
                                        duration: 0.5,
                                        ease: "power2.inOut",
                                    }, 'start')

							tl.eventCallback("onComplete", () => {
								resolve();
							});
						});
					},
                    beforeEnter(data){
                        const currentDOM = data.next.container;

						const main = currentDOM.querySelector('.ss-main');
						const isHomePage = main.classList.contains('ss-home-main');
						gsap.set(main, {
							autoAlpha: 0,
						});

						if (!isHomePage) {
							// pageHeaderBeforeEnterAnimation(currentDOM);
							const pageHeader = currentDOM.querySelector('.ss-page-header');

							const pageHeaderTop = pageHeader.querySelector('.ss-page-header__top');
							const pageHeaderTopInner = pageHeader.querySelector('.ss-page-header__top h1');
							const pageHeaderTextContainer = pageHeader.querySelector('.ss-page-header-text');
							const pageHeaderText = pageHeader.querySelector('.ss-page-header-text p');
							const pageHeaderArrow = pageHeader.querySelector('.ss-page-header-arrow');
						
							if (pageHeader) {
								gsap.set(pageHeaderTop, {
									scaleY: 0,
									transformOrigin: "bottom"
								})
								gsap.set(pageHeaderTopInner, {
									autoAlpha: 0,
								})
								gsap.set(pageHeaderTextContainer, {
									scaleX: 0,
									transformOrigin:"left"
								})
								gsap.set(pageHeaderText, {
									autoAlpha: 0,
									y: "2rem",
								})
								gsap.set(pageHeaderArrow, {
									scaleY: 0,
									transformOrigin:"top"
								})
							}
						}

                        data.current.container.remove();
                    },
					async enter(data) {
						await new Promise(resolve => {
                            const currentDOM = data.next.container;

							const main = currentDOM.querySelector('.ss-main');
							const pageHeader = currentDOM.querySelector('.ss-page-header');

							const tl = gsap.timeline()
								.addLabel('start')
								.to(main, {
									autoAlpha: 1,
									duration: 0.3,
									ease: "power1.inOut",
									clearProps: 'all',
								}, 'start');

							if (pageHeader) {
								// pageHeaderEnterAnimation(pageHeader);
								const pageHeaderTop = pageHeader.querySelector('.ss-page-header__top');
								const pageHeaderTopInner = pageHeader.querySelector('.ss-page-header__top h1');
								const pageHeaderTextContainer = pageHeader.querySelector('.ss-page-header-text');
								const pageHeaderText = pageHeader.querySelector('.ss-page-header-text p');
								const pageHeaderArrow = pageHeader.querySelector('.ss-page-header-arrow');
						
							
								tl.to(pageHeaderTop, {
									scaleY: 1,
									duration: 0.5,
									ease: "expo.out",
									clearProps: 'all',
								}, 'start+=0.3')
								.to(pageHeaderTopInner, {
									autoAlpha: 1,
									duration: 0.2,
									ease: "power3.inOut",
									clearProps: 'all',
								}, 'start+=0.8')
								.to(pageHeaderTextContainer, {
									scaleX: 1,
									duration: 0.6,
									ease: "expo.out",
									clearProps: 'all',
								}, 'start+=0.8')
								.to(pageHeaderText, {
									autoAlpha: 1,
									y: 0,
									duration: 0.4,
									ease: "power2.inOut",
									clearProps: 'all',
								}, 'start+=1.2')
								.to(pageHeaderArrow, {
									scaleY: 1,
									duration: 0.5,
									ease: "expo.out",
									clearProps: 'all',
								}, 'start+=1.5');
							}

							tl.eventCallback("onComplete", () => {
								document.body.classList.remove('on-transition');
								resolve();
							});

						});
					},
				}, 
			],
		});

		// Handle anchor links
		// handleAnchorLinks();

  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

// window.addEventListener('load', App.init)


window.addEventListener('load', () => {
    App.init();
    handleAnchorLinks();
});

// Function to handle anchor links
function handleAnchorLinks() {
    // Handle clicks on anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                barba.go(this.href).then(() => {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                });
            }
        });
    });

    // Handle scrolling if there is a hash in the URL on page load
    if (window.location.hash) {
        const targetElement = document.querySelector(window.location.hash);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // Handle scrolling after Barba.js loads a new view
    barba.hooks.after(() => {
        if (window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });

    // Handle hash changes
    window.addEventListener('hashchange', () => {
        const targetElement = document.querySelector(window.location.hash);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    });

    // Handle popstate events (back/forward navigation)
    window.addEventListener('popstate', () => {
        if (window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
}
